import { render, staticRenderFns } from "./RealEstateGroupMetricsDashboard.vue?vue&type=template&id=74c70355&scoped=true"
import script from "./RealEstateGroupMetricsDashboard.vue?vue&type=script&lang=js"
export * from "./RealEstateGroupMetricsDashboard.vue?vue&type=script&lang=js"
import style0 from "./RealEstateGroupMetricsDashboard.vue?vue&type=style&index=0&id=74c70355&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c70355",
  null
  
)

export default component.exports